import Base from 'records/Base';
import Editor from 'records/Editor';

import {
  EDITOR_ACTION_START,
  EDITOR_ACTION_ERROR,
  EDITOR_LOAD_USER_INFO_ACTION_SUCCESS,
  EDITOR_FINISH_PRODUCT_DESIGN_ACTION_SUCCESS,
  EDITOR_REMOVE_CURRENT_SURFACE_ACTION_SUCCESS,
  EDITOR_ADD_SURFACE_ACTION_SUCCESS,
  EDITOR_UPDATE_SUCCESS,
  EDITOR_RESET_STATE,
  EDITOR_SWAP_SURFACE_ACTION_SUCCESS,
} from 'actions/editor';

const initialState = new Base({
  loading: false,
  errorMessage: null,
  data: new Editor(),
});

const actionsMap = {
  [EDITOR_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [EDITOR_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [EDITOR_LOAD_USER_INFO_ACTION_SUCCESS]: (state, action) => {
    const newData = state.get('data').set('userInfo', action.userInfo);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newData,
    });
  },
  [EDITOR_FINISH_PRODUCT_DESIGN_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [EDITOR_REMOVE_CURRENT_SURFACE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [EDITOR_ADD_SURFACE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [EDITOR_SWAP_SURFACE_ACTION_SUCCESS]: (state) => {
    return state.merge({
      loading: false,
      errorMessage: null,
    });
  },
  [EDITOR_UPDATE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: new Editor({
        editor: action.editor,
      }),
    });
  },
  [EDITOR_RESET_STATE]: () => {
    return initialState;
  },
};

export default function editor(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
